(() => {
  const index = document.getElementById('miez-search-catalog');
  if (!index) return;
  let products; try { products = JSON.parse(index.textContent); } catch { return; }
  const clean = text => text.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const aliases = { pink:'flamingo', purple:'lavender', blue:'ocean navy aqua', red:'dashing red', orange:'poppy orange', brown:'chocolate peanut butter galao', green:'olive', panty:'panties', underwear:'panties', knickers:'panties', bras:'bra', bralettes:'bralette' };
  const bottoms = /bikini|hipster|thong|boyshort/;
  function find(query) {
    const normalized = clean(query);
    if (normalized.length < 2) return [];
    const matching = /matching (set|sets)|co ord|coordinated/.test(normalized);
    const original = normalized.split(/\s+/);
    const expanded = original.map(word => aliases[word] || word);
    const ignored = new Set(['comfortable','comfort','everyday','daily','soft','a','an','the','for','and','women','womens']);
    const tokens = expanded.filter(word => !ignored.has(word));
    const enhanced = matching || original.some(word => aliases[word] || ignored.has(word));
    if (!enhanced || (!matching && !tokens.length)) return [];
    let matches = products.filter(product => {
      if (matching) return product.available;
      const text = clean([product.title,product.description,...product.colours,...product.tags].join(' '));
      return tokens.every(token => {
        if (token === 'panties') return bottoms.test(product.handle);
        if (token === 'bra') return product.handle.includes('bra') && !product.handle.includes('bralette');
        if (token === 'bralette') return product.handle.includes('bralette');
        return token.split(' ').some(part => text.includes(part));
      });
    });
    matches.sort((a,b) => Number(b.available)-Number(a.available));
    if (matching) {
      const top = matches.find(item => item.handle.includes('bra'));
      if (!top) return [];
      const colour = top.variants.find(variant => variant.available)?.colour;
      const same = matches.filter(item => item.variants.some(variant => variant.available && variant.colour === colour));
      const tops = same.filter(item => item.handle.includes('bra'));
      const pants = same.filter(item => bottoms.test(item.handle));
      matches = []; for (let i=0;i<Math.max(tops.length,pants.length);i++) { if(tops[i])matches.push(tops[i]); if(pants[i])matches.push(pants[i]); }
      return matches.map(item => ({...item, matchColour:colour}));
    }
    return matches.map(item => ({...item,matchColour:item.colours.find(colour => expanded.some(token => token.split(' ').includes(clean(colour))))}));
  }
  function render(host,query) {
    const list = host.querySelector('[data-miez-search-items]');
    const matches = find(query);
    host.hidden = !matches.length;
    host.querySelector('h2').textContent = /matching|co.?ord/i.test(query) ? host.dataset.matching : host.dataset.heading;
    list.replaceChildren();
    for (const product of matches.slice(0,host.dataset.miezSearchMode === 'page' ? 24 : 6)) {
      const link = document.createElement('a');
      const variant = product.matchColour && (product.variants.find(item => item.available && item.colour === product.matchColour) || product.variants.find(item => item.colour === product.matchColour));
      link.href = product.url + (variant ? '?variant='+variant.id : '');
      const imageUrl = variant?.image || product.image;
      if (imageUrl) { const image = document.createElement('img'); image.src=imageUrl; image.alt=''; image.width=240; image.height=300; image.loading='lazy'; link.append(image); }
      const title=document.createElement('span');title.textContent=product.title;link.append(title);
      if(product.matchColour) { const colour=document.createElement('small');colour.textContent=product.matchColour;link.append(colour); }
      const price=document.createElement('span');price.textContent=product.price;link.append(price);list.append(link);
    }
    return matches.length;
  }
  function initialize() {
    document.querySelectorAll('[data-miez-search-mode]').forEach(host => {
      if (host.dataset.initialized) return;host.dataset.initialized='true';
      if(host.dataset.miezSearchMode==='page') {
        if(host.dataset.query && render(host,host.dataset.query) && Number(host.dataset.nativeCount) === 0) host.closest('[data-section-id]')?.classList.add('miez-search-fallback');
        return;
      }
      const drawer=host.closest('search-drawer');const input=drawer?.querySelector('input[name="q"]');if(!input)return;
      const update=()=>drawer.classList.toggle('miez-search-has-matches',Boolean(render(host,input.value)));
      input.addEventListener('input',update);
      drawer.querySelector('.wt-header__search__clear-button')?.addEventListener('click',()=>{host.hidden=true;drawer.classList.remove('miez-search-has-matches');});
      drawer.querySelectorAll('[data-miez-search-suggestion]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();input.value=link.dataset.miezSearchSuggestion;input.dispatchEvent(new Event('input',{bubbles:true}));input.focus();}));
    });
  }
  initialize();document.addEventListener('shopify:section:load',initialize);
})();
